import * as React from "react";
import styled, { css } from "styled-components";

import { Label } from "src/library/components/Forms";
import { Icon } from "src/library/components/Icon";
import { Text } from "src/library/components/Text";
import { Tooltip } from "src/library/components/Tooltip";
import { Icons } from "src/library/components/Icon/types";
import useTimezone from "src/core/shared/hooks/time-helpers/useTimeZone";

import { CutoffTimeSelection } from "../CutoffTimeSelection";

interface DefaultCutoffProps {
  handleChange: (time: string) => void;
  value: string;
  disabled: boolean;
}

/** On lead time pages displays the current default cutoff and dropdown to change it */
export const DefaultCutoff: React.FC<DefaultCutoffProps> = ({
  handleChange, value, disabled
}) => {
  const timezone = useTimezone();

  return (
    <DefaultCutoffWrapper>
      <div
        className="label-wrapper"
        data-tip
        data-for="cutoff-tooltip"
      >
        <Label
          for="default-cutoff"
          label="Default cutoff time"
        />

        <Icon
          icon={Icons.HELP}
          size={10}
        />

        {" "}

        <Tooltip
          id="cutoff-tooltip"
          type="dark"
          place="top"
          getContent={() => {
            return (
              <Text color="white">
                The default cutoff time is used where no override value has been set in the lead times table below
              </Text>
            );
          }}
        />
      </div>

      <CutoffTimeSelection
        setTime={handleChange}
        value={value}
        name="default-cutoff"
        timezone={timezone}
        disabled={disabled}
      />
    </DefaultCutoffWrapper>
  );
};

const DefaultCutoffWrapper = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing.margins.xl};

    .label-wrapper {
      display: flex;
    }
  `}
`;

export default DefaultCutoff;
